import { ConsultationResponseResource } from '@aorg/models/resources/Consultation/ConsultationResponseResource';
import { ConversationResource } from '@aorg/models/resources/Conversation/ConversationResource';
import api from '..';

type requestConsultationResponseProps = {
  consultation_id: string;
  response: string;
};

function createConsultationResponse({
  consultation_id,
  response,
}: requestConsultationResponseProps) {
  const payload = {
    response: response,
  };

  return api.post<{ data: ConsultationResponseResource }>(
    `/api/experts/consultations/${consultation_id}/response`,
    payload
  );
}

export type { ConversationResource, requestConsultationResponseProps };
export default createConsultationResponse;
